import React, { useState } from 'react';
import { Button, Dropdown, Row } from 'react-bootstrap';
import FunctionalTableComponent from '../../components/table/FunctionalTableComponent';
import columns from './SearchCustomerTableConfig';
import { Actions } from '../../../client/Actions';
import { useLoader } from '../../components/loader/useLoader';
import fields from './SearchCustomerFormConfig';
import CardFormNew from '../../components/form/CardFormNew';
import { useLoaderContext } from '../../components/loader/LoaderContext';
import LightButton from '../../components/button/LightButton';
import { FaCalendar, FaCalendarAlt } from 'react-icons/fa';

const SearchCustomer = ({
                          selectCustomer,
                          goToReservations,
                          editable = false,
                          removable = false,
                          creationFields,
                          deleteModalTitle,
                          modalSize,
                          deleteApi,
                          deleteModalDescription,
                          editWithId,
                          api,
                          creationTitle,
                          createApi,
                          forceDropdown=false,
                          title = 'Wynnik wyszukiwania'
                        }) => {
  const { loader, setLoader } = useLoaderContext();
  const [formKey, setFormKey] = useState(Date.now());
  const [searchParams, setSearchParams] = useState();

  function onCustomersFound(result) {
    setLoader(false);

    setFormKey(Date.now());
  }

  function searchCustomer(params) {
    setLoader(true);
    setFormKey(Date.now());
    setSearchParams(params);
    // setCustomers(undefined);
  }

  return (
    <>
      <Row>
        <CardFormNew
          shadow={false}
          title={'Wyszukaj klienta'}
          fields={fields}
          width={4}
          saveButton={'Wyszukaj'}
          customSave={searchCustomer}
        />
        {searchParams &&
          <FunctionalTableComponent
            key={formKey}
            shadow={false}
            title={title}
            columns={columns}
            header={true}
            editable={editable}
            removable={removable}
            api={api}
            creationTitle={creationTitle}
            deleteApi={deleteApi}
            creationFields={creationFields}
            modalSize={modalSize}
            deleteModalTitle={deleteModalTitle}
            editWithId={editWithId}
            deleteModalDescription={deleteModalDescription}
            forceDropdown={forceDropdown}
            apiFunction={(onLoaded) => Actions.post('customer/search', searchParams, onLoaded)}
            additionalButtons={function(row) {
              return (
                <>
                  {selectCustomer && (
                    <LightButton
                      onClick={() => {
                        selectCustomer(row);
                      }}
                    >
                      Wybierz
                    </LightButton>
                  )}
                  {goToReservations && (
                    <LightButton
                      onClick={() => {
                        goToReservations(row.id);
                      }}
                    >
                      Rezerwacje
                    </LightButton>
                  )}
                </>
              );
            }}
            additionalButtonsDropdown={function(row) {
              return (
                <>
                  {selectCustomer && (
                    <Dropdown.Item
                      onClick={() => {
                        selectCustomer(row);
                      }}
                    >
                      Wybierz
                    </Dropdown.Item>
                  )}
                  {goToReservations && (
                    <Dropdown.Item
                      onClick={() => {
                        goToReservations(row.id);
                      }}
                    >
                      Rezerwacje
                    </Dropdown.Item>
                  )}
                </>
              );
            }}
            additionalButtonsConfig={function(row) {
              return [
                {
                  onClick: () => {
                    goToReservations(row.id);
                  },
                  label: 'Rezerwacje',
                  show: goToReservations,
                  icon: <FaCalendarAlt/>
                },
                {
                  onClick: () => {
                    selectCustomer(row);
                  },
                  label: 'Wybierz',
                  show: selectCustomer
                }
              ];
            }}


            width={8}
          />
        }

      </Row>
    </>
  );
};

export default SearchCustomer;
